import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 DURACIÓN — horas y minutos

    Distinto de FieldTime: eso es un momento del día, esto es cuánto
    dura algo. El valor son MINUTOS TOTALES, que es lo que conviene
    guardar: sumar duraciones con "2h 30m" es un dolor.
*/

export const FieldDuration = ({
    id, label, hint, error,
    value = 0,                      // minutos totales
    onChange, maxHours = 99, step = 5,
    isDisabled = false, span = 1,
}) => {

    const TOTAL = Number(value) || 0;

    const HOURS = Math.floor(TOTAL / 60);
    const MINUTES = TOTAL % 60;

    const onSetHours = (event) => {
        const H = Math.min(maxHours, Math.max(0, Number(event.target.value) || 0));
        onChange?.(H * 60 + MINUTES);
    };

    const onSetMinutes = (event) => {
        const M = Math.min(59, Math.max(0, Number(event.target.value) || 0));
        onChange?.(HOURS * 60 + M);
    };

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled}
            hint={hint ?? `${TOTAL} minutos en total`} >

            <div className={`${BLOCK}__duration`}>

                <div className={`${BLOCK}__duration_part`}>
                    <input name={DOM_NAME} autoComplete="nope" data-lpignore="true" data-1p-ignore="true" data-form-type="other" spellCheck={false} autoCorrect="off" autoCapitalize="off" id={DOM_ID} type="number" className={`${BLOCK}__input`}
                        value={HOURS} onChange={onSetHours}
                        min={0} max={maxHours} disabled={isDisabled} aria-label="Horas" />
                    <span>h</span>
                </div>

                <div className={`${BLOCK}__duration_part`}>
                    <input name={DOM_NAME} autoComplete="nope" data-lpignore="true" data-1p-ignore="true" data-form-type="other" spellCheck={false} autoCorrect="off" autoCapitalize="off" type="number" className={`${BLOCK}__input`}
                        value={MINUTES} onChange={onSetMinutes}
                        min={0} max={59} step={step} disabled={isDisabled} aria-label="Minutos" />
                    <span>min</span>
                </div>

            </div>

        </FieldShell>
    );
};
